export function isElementPartiallyInViewport(element: HTMLElement) {
    if (!element) {
        return false;
    }

    const rect = element.getBoundingClientRect();

    // Проверяем, пересекаются ли границы элемента с границами viewport
    const isVerticallyVisible =
        rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.bottom > 0;
    const isHorizontallyVisible =
        rect.left < (window.innerWidth || document.documentElement.clientWidth) && rect.right > 0;

    return isVerticallyVisible && isHorizontallyVisible;
}
